import React, { Component } from 'react';

import Paper from 'material-ui/Paper';
import Chart from 'chart.js';

import moment from 'moment';

class TemperatureChart extends Component {

    componentDidMount() {
        this.chart = new Chart(this.refs.ctx, { type: 'line', responsive: true });
        this.updateChart(this.props);
    }

    updateChart(props) {
        const labels = [];
        const data = [];
        const max_temperature = [];
        const averange_temperature = [];

        let last_temperature_time;

        props.temperatures.forEach((temperature, index) => {
            if (index === 0) {
                last_temperature_time = moment(temperature.datetime);
            }

            const current_time = moment(temperature.datetime);
            const diff = current_time.diff(last_temperature_time, 'minutes');

            if (diff >= this.props.interval) {
                labels.push(current_time.format('HH:mm'));
                data.push(temperature.temperature);

                averange_temperature.push(0);
                max_temperature.push(4);

                last_temperature_time = moment(temperature.datetime);
            }
        });

        const datasets = [
            { fill: false, label: 'Temperatura Média', data: averange_temperature, borderColor: '#F4C53D', backgroundColor: '#F4C53D' },
            { fill: false, label: 'Temperatura Máxima', data: max_temperature, borderColor: '#D70D05', backgroundColor: '#D70D05' },
        ];

        console.log(data.length);

        if (data.length) {
            datasets.push({ fill: false, label: 'Temperatura do Veículo', data, borderColor: '#3D88EC', backgroundColor: '#3D88EC'});
        }

        this.chart.data = { labels, datasets };
        this.chart.update();
    }

    componentWillReceiveProps(props) {
        this.updateChart(props);
    }

    render() {
        return (
            <Paper style={{padding: '8px'}}>
                <canvas ref="ctx" style={{width: '100%'}}></canvas>
            </Paper>
        );
    }

}

export default TemperatureChart;



// WEBPACK FOOTER //
// ./src/components/Temperature/Chart.js